import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { getTennisEvents } from '../../../selectors/events';
import { getTennisOddsHistoryTemplate } from '../../../selectors/common';
import { getMatchId } from '../../../selectors/oddsHistory';
import {
  PAGES,
} from '../../../constants';
import { getTennisEventDetails, getTennisMatchTimeline } from '../../../selectors/matchTimeline';
import OddsHistory1 from '..';
import { aGetTennisMatchTimelineRequest } from '../../../reducers';
import { aSetSelectedRowMatchId } from '../../../reducers/oddsHistory';

const mapToProps = (state) => ({
  events: getTennisEvents(state),
  matchId: getMatchId(state),
  eventDetails: getTennisEventDetails(state),
  matchTimeline: getTennisMatchTimeline(state),
  oddsHistoryTemplate: getTennisOddsHistoryTemplate(state),
});

const actionsToProps = (dispatch) => ({
  getTennisMatchTimeline: (payload) => dispatch(aGetTennisMatchTimelineRequest(payload)),
  setSelectedRowMatchId: (payload) => dispatch(aSetSelectedRowMatchId(payload)),
});

const TennisOddsHistory1 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    const matchId = parseInt(props.matchId || (pathname.split(`${PAGES.TENNIS_ODDS_HISTORY_STEP_1}/`)[1]));
    if (matchId) {
      props.getTennisMatchTimeline({
        matchId,
      });
      props.setSelectedRowMatchId({
        selectedRowMatchId: matchId,
      });
    }
  // eslint-disable-next-line
  }, []);

  return (
    <OddsHistory1
      navigate={navigate}
      eventDetails={props.eventDetails}
      oddsStep1Page={PAGES.TENNIS_ODDS_HISTORY_STEP_1}
      oddsStep2Page={PAGES.TENNIS_ODDS_HISTORY_STEP_2}
      oddsHistoryTemplate={props.oddsHistoryTemplate}
      matchTimeline={props.matchTimeline}
      matchId={props.matchId}
      isTennis
    />
  );
};

export default connect(mapToProps, actionsToProps)(TennisOddsHistory1);
